import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const RVRepair = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my rv repair business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps rv repair businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for rv repair businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most rv repair businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my rv repair business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like rv repair. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for RV Repair - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "RV Repair CRM", url: "/industries/rv-repair" }
  ];

  const industryData = {
    name: 'RV Repair & Service',
    title: 'Capture Pre-Trip Service Calls & Build Recurring Maintenance Revenue',
    subtitle: 'Never miss urgent repair requests, automate seasonal reminders, and manage complex RV service projects',
    icon: '🚙',
    challenges: [
      'Last-minute vacation prep creates chaos',
      'Customers forget annual maintenance',
      'Emergency repairs interrupt workflow',
      'Hard to schedule long service jobs',
      'Parts availability delays'
    ],
    solutions: [
      'Pre-trip service automation',
      'Annual maintenance reminders',
      'Emergency repair routing',
      'Extended service scheduling',
      'Parts tracking system'
    ],
    features: [
      'Customer CRM with RV details',
      'Pre-trip checklist automation',
      'Seasonal maintenance reminders',
      'Service bay scheduling',
      'Parts inventory management',
      'Warranty tracking',
      'Mobile service coordination',
      'Review automation'
    ],
    results: [
      '85% pre-season service capture',
      'Book 6-8 weeks in advance',
      '70% become annual customers',
      '£7.6K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for RV Repair UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for rv repair businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for rv repair UK, rv repair business software, rv repair customer management, rv repair lead generation UK"
        url="/industries/rv-repair"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default RVRepair;